





























































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringKritisIgdSvc from "@/services/MonitoringKritisIgdService";
import { appModule } from "@/store/modules/app";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class MonitoringKritisIgdDisposisi extends Vue {
  @Prop() monitoring!: any;
  @Prop({ default: false }) readonly!: boolean;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  savingDisposisi = false;

  disposisiForm: any = {
    disposisi: null,
    transfer_at: "",
    outcome_notes: "",
  };

  disposisiOptions = [
    { text: "ICU", value: "icu" },
    { text: "HCU", value: "hcu" },
    { text: "OK (Kamar Operasi)", value: "ok" },
    { text: "Rawat Inap", value: "ranap" },
    { text: "Observasi IGD", value: "observasi_igd" },
    { text: "Rujuk", value: "rujuk" },
    { text: "Pulang", value: "pulang" },
    { text: "Meninggal", value: "meninggal" },
    { text: "DOA (Dead on Arrival)", value: "doa" },
  ];

  mounted() {
    if (this.monitoring) {
      this.disposisiForm.disposisi = this.monitoring.disposisi;
      this.disposisiForm.transfer_at = this.monitoring.transfer_at || "";
      this.disposisiForm.outcome_notes = this.monitoring.outcome_notes || "";
    }
  }

  async simpanDisposisi() {
    if (this.readOnly) return;
    this.savingDisposisi = true;
    try {
      const resp = await MonitoringKritisIgdSvc.disposisi(this.monitoring.id, this.disposisiForm);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Disposisi berhasil disimpan");
        this.$emit("saved");
      }
    } catch { /* handled */ }
    this.savingDisposisi = false;
  }
}
